import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Task } from '../../../model/task.model';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { StoreService } from '../../../../../services/store.service';
import { Router } from '@angular/router';
import { ORDER_DETAILS_URL } from '../../../../../config/url.config';

@Component({
  selector: 'order-cell',
  templateUrl: './order-cell.component.html',
  styleUrls: ['./order-cell.component.scss']
})
export class OrderCellComponent implements ICellRendererAngularComp {

  cellValue!: Task;
  params!: ICellRendererParams;

  constructor(
    public store: StoreService,
    private router: Router
  ) {
  }



  refresh(params: ICellRendererParams): boolean {
    this.cellValue = params.data;
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.params = params;
    this.cellValue = params.data;
  }

  goToOrder(event: MouseEvent) {
    event.stopPropagation();

    void this.router.navigate([ORDER_DETAILS_URL, this.cellValue.order.id])
  }
}
